import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { stopPropagation } from '../../../utils/events'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { useWidgetContext } from '../Widget.hooks'

import { QA_NAME_WIDGET_HEADER_EDIT_BTN } from './WidgetHeaderContentActionsEditButton.constants'

import EditIcon from '../../../icons/edit.svg'

function WidgetHeaderContentActionsEditButton({
  qaName = QA_NAME_WIDGET_HEADER_EDIT_BTN,
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleEnableEditMode, handleToggleExpanded, isEditMode, isExpanded } =
    useWidgetContext()

  function handleClick(event) {
    stopPropagation(event)

    if (!isExpanded) {
      handleToggleExpanded(event)
    }

    handleEnableEditMode()
  }

  return isEditMode ? null : (
    <Button.Outlined
      {...restProps}
      isGrey
      beforeIconProps={{ Icon: EditIcon }}
      height={BUTTON_HEIGHT_32}
      qaName={qaName}
      tooltip={t('Common.WidgetHeaderEditButtonOpenTooltipKey')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClick}
    />
  )
}

export default WidgetHeaderContentActionsEditButton
